var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls054(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.67822,
    y: 65.1582,
    width: 69.8364,
    height: 69.8364,
    rx: 10,
    transform: "rotate(-60 4.67822 65.1582)",
    fill: "#5D77FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.107 59.3552C35.1228 58.3451 34.1918 54.7172 35.7309 52.3241C36.0861 51.7718 36.5746 51.2841 37.1978 50.9108L54.1444 40.7679C57.2228 38.9238 61.2851 41.2692 61.2273 44.8572L60.9165 64.6048C60.8542 68.4791 56.062 70.5987 53.1489 68.0396L46.7312 62.4081C46.5764 62.2722 46.3877 62.1633 46.1928 62.0973L38.107 59.3552ZM38.8028 53.5914C38.4939 53.7765 38.2706 54.0159 38.1354 54.2781C37.7279 55.0636 38.0847 56.0542 39.109 56.4009L46.5836 58.9342L49.063 54.6397C49.1022 54.5552 49.1489 54.4744 49.2024 54.3982C49.6979 53.6942 50.6709 53.5254 51.3757 54.0212C52.0805 54.5171 52.2502 55.4897 51.7548 56.1937L49.2753 60.4883L55.2064 65.6948C56.2898 66.6465 57.7694 65.9957 57.7926 64.5551L58.1033 44.8075C58.1242 43.5036 56.868 42.7783 55.7494 43.4484L38.8028 53.5914Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls054);
export default __webpack_public_path__ + "static/media/ils_05_4.d64a6c4cb3c4c6b586dc294728595330.svg";
export { ForwardRef as ReactComponent };